<template lang="pug">
v-dialog(v-model="dialog", persistent, scrollable, max-width="1300")
  v-card(v-if="!welcomePassed")
    .pa-4
      h2.text-center.mb-4 Welcome to Nation.better!
      p.text-center.mb-4
        | Your company is currently applying to become a licensed sponsor,
        | and would like for you to provide
        br
        | information about your current circumstances
        | to speed up the process of sponsoring you.
      .btns
        .d-flex.justify-center
          v-btn(color="primary", @click="openCaseQuiz") continue
</template>

<script>
export default {
  data: () => ({
    welcomePassed: false,
  }),

  methods: {
    openCaseQuiz() {
      this.welcomePassed = true;
      this.$store.dispatch("flows/openQuiz", {
        alias: this.userflow.flow.alias,
      });
    },
  },

  computed: {
    dialog() {
      return (
        this.$auth.user().role == "candidate" &&
        this.userflow &&
        this.userflow.status == "in progress"
      );
    },

    userflow() {
      const filteredFlows = this.$store.state.flows.list.filter(
        (uf) => uf.flow.alias == "candidate"
      );
      if (filteredFlows.length > 0) return filteredFlows[0];
      return {};
    },
  },
};
</script>
